
<template>
  <div class="container">
    <div class="selected-field">
      <template v-if="selectedItems && selectedItems.length">
        <div class="item" v-for="v, i in selectedItems" :key="i">
          <selector-item :itemData="v" @remove="removeSelected"></selector-item>
        </div>
      </template>
      <div v-else class="empty item">请选择</div>
      <div class="arrow">
        <i class="iconfont iconxiala"></i>
      </div>
    </div>
    <div class="options-field">
      <div class="options-popover">
        <div class="option" v-for="v, i in optionItems" :key="i" @click="selectOption(v)">
          {{v.text}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import selectorItem from './selectorItem.vue';
export default {
  components: {
    selectorItem
  },
  props: {
    optionItems: {
      type: Array,
      default () {
        return [];
      }
    },
    selectedLabels: {
      type: Array,
      default () {
        return [];
      }
    },
    selectorLabel: {
      type: [String, Number],
      default () {
        return '';
      }
    }
  },
  data () {
    return {};
  },
  computed: {
    selectedItems () {
      return this.optionItems.filter(v => this.selectedLabels.includes(v.label));
    }
  },
  methods: {
    selectOption(item) {
      this.$emit('selectOption', item, this.selectorLabel);
    },
    removeSelected(item) {
      this.$emit('removeSelected', item, this.selectorLabel);
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  & > .options-field {
    display: none;
  }
  &:hover > .options-field {
    display: block;
  }
  &:hover > .selected-field {
    & > .arrow > .iconfont {
      transform: scale(0.33) rotate(180deg);
    }
  }
}
.options-field {
  position: absolute;
  z-index: 999;
  top: 100%;
  left: 0;
  width: 100%;
  padding-top: 5px;
}
.selected-field {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  width: 307px;
  min-height: 50px;
  border: 1px solid #DDD9EB;
  border-radius: 4px;
  padding: 0 7px;
  & > .item {
    margin: 7px 3px;
    &.empty {
      display: flex;
      align-items: center;
      color: #aaa
    }
  }
  & > .arrow {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: absolute;
    height: 100%;
    right: 0;
    top: 0;
    & > .iconfont {
      transform: scale(0.33);
    }
  }
}
.options-popover {
  width: 100%;
  max-height: 250px;
  background: #FFFFFF;
  border: 1px solid #DDD9EB;
  border-radius: 4px;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 6px;
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d8dee9;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #bdbdbe;
  }
}
.option {
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  color: #474261;
  padding-left: 17px;
  padding-right: 17px;
  &:hover {
    background: #F8F8FC;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/multiSelector/selectorContainer.vue